/** 
* 自动生成文件，请勿修改 
* @name: 支出:其他支出申请审批流程设置
* @description: 其他支出申请审批流程设置（四期新增（董灿提出））
* @create: 2024/1/11 下午4:25:21
* @swagger: 2.0
* 合计:6条
*/ 
 
import APIObject from "../utils/APIObject.js" 
const otherPayAudit = { 
	/** 1 summary:批量删除	method:post */ 
	batchDelete : new APIObject("/api/otherPayAudit/batchDelete.do"), 
	/** 2 summary:单条删除	method:post */ 
	delete : new APIObject("/api/otherPayAudit/delete.do"), 
	/** 3 summary:分页查询	method:post */ 
	queryPage : new APIObject("/api/otherPayAudit/queryPage.do"), 
	/** 4 summary:所有数据查询	method:post */ 
	queryAll : new APIObject("/api/otherPayAudit/queryAll.do"), 
	/** 5 summary:单条数据查询	method:post */ 
	queryOne : new APIObject("/api/otherPayAudit/queryOne.do"), 
	/** 6 summary:保存/修改	method:post */ 
	saveOrUpd : new APIObject("/api/otherPayAudit/saveOrUpd.do"), 
};
export default otherPayAudit;